import React, { Component }              from 'react';
import { connect }                       from 'react-redux'
import { setPlace }                      from './../actions/PlaceAction';
import Place                             from '../components/Place';

class PlaceContainer extends Component {

    /**
     * Fetch the selected place into the state.
     */
    componentWillMount = () =>
    {
        if (this.props.geo.resolved)
        {
            this.props.setPlace(this.props.placeId);
        }
    };

    componentWillReceiveProps = (nextProps) =>
    {
        if (this.props.placeId !== nextProps.placeId || this.props.geo.resolved !== nextProps.geo.resolved)
        {
            this.props.setPlace(nextProps.placeId);
        }
    };

    render = () => {
        return (<Place { ...this.props } />)
    }

}

const mapStateToProps = (state) => {
    return {
        geo        : state.geo,
        theme      : state.assets.items.theme,
        selected   : state.place.id,
        place      : state.place.item,
        isFavourite: state.place.favourite
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPlace: (placeId) => {
            dispatch(setPlace(placeId));
        }
    }
};

PlaceContainer = connect(mapStateToProps, mapDispatchToProps)(PlaceContainer);

export default PlaceContainer;


// WEBPACK FOOTER //
// ./src/containers/PlaceContainer.js